import { postMessageToken } from '../postTokenRefreshResultToParent';

function render(context) {
    postMessageToken(context.shared.iframe, 'bbcidv5_token_error');
}

function tearDown(context, next) {
    next();
}

export { render, tearDown };
